import Search from "../../search/Search";
import SearchApi from "../../../api/SearchApi";

const VisitorCheck = () => {
    return (
        <Search
            type={'keywords'} 
            api={SearchApi.searchVisitorCounts}
            useKeyword={false} 
            targetPlaceholder={'블로그 아이디 입력'}
            headers={['방문자 수']}
            dataIdx={[6]}
            dataManupulator={data => {
                return data.split('\n').map(v => (
                    <>{v}<br/></>
                ))
            }} 
        />
    );
}

export default VisitorCheck;